import {axiosInstance} from "@/plugins/axios";
import {Bom} from "@/modules/bom/types";

export async function getBoms(id: string) {
  const response = await axiosInstance.get(`boms/${id}`);
  return response.data;
}

export async function saveBoms(boms: Bom[]) {
  await axiosInstance.post(`boms/create_or_update_many`, {
    boms: boms
  });
}
